var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.onboardingInfo.distributor)?_c(_vm.whichFlow,{tag:"component",attrs:{"distributor":_vm.onboardingInfo.distributor,"venue":_vm.onboardingInfo.venue,"token":_vm.token,"from-shopping-cart":_vm.isFromShoppingCart}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }